let settings = {
    playLimit: 1, // 1日にプレイ可能な回数
    totalRound: 10, // 1回あたりのラウンド数
};

export default settings;
